<template>
	<div :class="['biz-searcher', {'active': isEdit}]" @click="foucusSearcher">
        <p class="placeholders" v-show="!searchParams.length && !isInputFocus">{{placeholder}}</p>
        <ul class="search-keys">
            <li class="key-node" v-for="(param, index) in searchParams">
                <span class="tag">{{param.text}}</span>
                <a href="javascript:void(0)" class="remove-key" @click.stop.prevent="removeSearchParams(param, index)">
                    <i class="bk-icon icon-close"></i>
                </a>
            </li>
            <li v-if="curParams">
                <input
                    type="text"
                    class="input"
                    v-model="curInputValue"
                    style="position: relative; margin-top: 0px;"
                    :style="inputStyle"
                    @focus="inputFocus"
                    @blur="inputBlur"
                    @keyup="inputKeyup">
            </li>
        </ul>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: {
            limitedValue: {
                type: Number
            },
            maxlength: {
                type: Number
            },
            placeholder: {
                type: String,
                default: '请输入不超过7个字符，并按Enter添加标签'
            },
            keyName: {
                type: String,
                default: 'Tag'
            },
            split: {
                type: String,
                default: '|'
            },
            tags: {
                type: Array,
                default () {
                    return ['a']
                }
            }
        },
        data () {
            let isShow = this.isShow
            return {
                timer: 0,
                isSelectListShow: false,
                isEdit: false,
                isShowFilterKey: false,
                isInputFocus: false,
                curParams: null,
                curSelectList: [],
                curInputValue: '',
                curKey: null,
                defaultKeys: [
                    {
                        name: 'IP',
                        key: 'ip',
                        type: 'input',
                        isSelected: false
                    },
                    {
                        name: '状态',
                        key: 'status',
                        type: 'select',
                        isSelected: false,
                        selectList: [
                            {
                                id: 1,
                                text: '正常',
                                isChecked: false
                            },
                            {
                                id: 2,
                                text: '异常',
                                isChecked: false
                            }
                        ]
                    }
                ],
                searchParams: []
            }
        },
        watch: {
            'curParams' () {
                this.curInputValue = this.curParams && this.curParams.name ? this.curParams.name + ': ' : ''
            },
            'tags' (val) {
                let results = []
                
                if(this.limitedValue) {
                    this.tags.forEach(tag => {
                        if(tag.length <= this.limitedValue) {
                            results.push({
                                key: 'tag',
                                name: 'tag',
                                type: 'input',
                                text: tag,
                                value: tag
                            })
                        } else {
                            tag = "";
                            results.push({
                                key: 'tag',
                                name: 'tag',
                                type: 'input',
                                text: tag,
                                value: tag
                            })  
                        }
                    })
                } else {
                    this.tags.forEach(tag => {
                        results.push({
                            key: 'tag',
                            name: 'tag',
                            type: 'input',
                            text: tag,
                            value: tag
                        })
                    })
               }
                
                this.searchParams.splice(0, this.searchParams.length, ...results)
            }
        },
        computed: {
            filterKeys () {
                let keys = []
                let filterKeys = []
                if (this.curInputValue === '') {
                    keys = JSON.parse(JSON.stringify(this.defaultKeys))
                } else {
                    keys = this.defaultKeys.filter((key) => {
                        let reg = new RegExp('^' + this.curInputValue)
                        return reg.test(key.name)
                    })
                }
                this.searchParams.forEach((params) => {
                    let name = params.name
                    keys.forEach((key) => {
                        if (name === key.name) {
                            key.isHas = true
                        }
                    })
                })

                filterKeys = keys.filter((key) => {
                    return !key.isHas
                })
                return filterKeys
            },
            inputStyle () {
                let inputValue = this.curInputValue
                let charLen = this.getCharLength(inputValue) + 1
                return {width: charLen * 8 + 'px'}
            }
        },
        methods: {
            getCharLength (str) {
                let len = str.length
                let bitLen = 0
                for (let i = 0; i < len; i++) {
                    if ((str.charCodeAt(i) & 0xff00) !== 0) {
                        bitLen++
                    }
                    bitLen++
                }
                return bitLen
            },
            inputKeyup (event) {
                switch (event.code) {
                    case 'Enter':
                        if(this.limitedValue) {
                            if(this.getLength( this.curInputValue) <= this.limitedValue) {
                                if (this.maxlength) {
                                    if (this.tags.length < this.maxlength) {
                                        this.setCurParams()
                                    } else {
                                        this.curInputValue = '';
                                    }
                                } else {
                                    this.setCurParams()
                                }
                            } else {
                                this.curInputValue = "";
                            }
                        } else {
                            this.setCurParams()
                        }
                        
                        break
                    case 'Backspace':
                        this.removeSearchLastParams()
                        break
                }
            },                                                              
            getLength(str){
              var len = 0;
              for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {                                                                               
                 len += 2;
               } else {
                 len++;
               }
            }
              return len;
           },
            initCurParams (data) {
                clearTimeout(this.timer)
                this.curKey = data
                data.isSelected = true
                this.setCurParamsKey()
                this.$nextTick(() => {
                    this.$el.querySelector('.input').focus()
                })
            },
            setCurParamsKey () {
                this.curParams.key = this.curKey.key
                this.curParams.name = this.curKey.name
                this.curInputValue = this.curKey.name + ': '
                if (this.curKey.selectList) {
                    this.curSelectList = this.curKey.selectList
                    this.isSelectListShow = true
                }
                this.curKey = null
            },
            setCurParams () {
                let inputVal = this.curInputValue
                // if (inputVal.length > 7) {
                //     inputVal = "";
                //     return false
                // }
                if (inputVal) {
                    this.curParams.key = this.keyName
                    this.curParams.name = this.keyName
                    this.curParams.text = inputVal
                    this.addSearchParams(this.curParams)
                    this.clearInputParams()
                }
            },
            selectKey (direction) {
                let curKeyIndex = -1
                let keyLen = this.filterKeys.length
                this.filterKeys.forEach((key, index) => {
                    if (key.isSelected) {
                        curKeyIndex = index
                    }
                })

                if (direction === 'down') {
                    curKeyIndex++
                    if (curKeyIndex >= keyLen) {
                        curKeyIndex = keyLen - 1
                    }
                } else {
                    curKeyIndex--
                    if (curKeyIndex <= 0) {
                        curKeyIndex = 0
                    }
                }

                this.filterKeys.forEach((key, index) => {
                    if (index === curKeyIndex) {
                        key.isSelected = true
                        this.curKey = key
                    } else {
                        key.isSelected = false
                    }
                })

                this.filterKeys.splice(0, keyLen, ...this.filterKeys)
            },
            clearInputParams () {
                // this.curParams = null
                this.curInputValue = ''
            },
            clearSearchParams () {
                this.isEdit = false
                this.curParams = null
                this.curInputValue = ''
                this.searchParams.splice(0, this.searchParams.length)
            },
            search () {
                let results = []
                this.searchParams.forEach((params) => {
                    results.push({
                        key: params.key,
                        value: params.text
                    })
                })
                this.$emit('search', results)
            },
            removeSearchLastParams () {
                if (this.curInputValue === '') {
                    this.searchParams.pop()
                    let tags = []
                    this.searchParams.forEach(item => {
                        tags.push(item.text)
                    })
                    this.$emit('change', tags)
                    this.$emit('update:tags', tags)
                }
            },
            removeSearchParams (data, index) {
                this.searchParams.splice(index, 1)
                let tags = []
                this.searchParams.forEach(item => {
                    tags.push(item.text)
                })
                this.$emit('change', tags)
                this.$emit('update:tags', tags)
            },
            addSearchParams (data) {
                let params = {
                    key: data.key,
                    name: data.key,
                    type: data.type,
                    text: data.text,
                    value: data.value
                }
                let isHas = false
                this.searchParams.forEach(item => {
                    if (item.text === data.text) {
                        isHas = true
                    }
                })
                
                if (!isHas) {
                    let index = this.searchParams.length
                    this.searchParams.splice(index, 1, params)
                    // alert(JSON.stringify(this.searchParams))
                   
                    let tags = []
                    this.searchParams.forEach(item => {
                        tags.push(item.text)
                    })
                    this.$emit('change', tags)
                    this.$emit('update:tags', tags)
                }
            },
            inputFocus () {
                this.isInputFocus = true
            },
            inputBlur () {
                this.isInputFocus = false
                this.timer = setTimeout(() => {
                    this.curParams = null
                    this.isEdit = false
                }, 300)
            },
            foucusSearcher () {
                clearTimeout(this.timer)
                this.isEdit = true
                this.isShowFilterKey = true
                if (!this.curParams) {
                    this.curParams = {
                        key: '',
                        name: '',
                        type: 'input',
                        text: '',
                        value: ''
                    }
                }
                this.$nextTick(() => {
                    this.$el.querySelector('.input').focus()
                })
            }
        }
    }
</script>

<style media="screen" lang="scss">
	.biz-searcher {
        width: 614px;
        padding: 1px 0 4px 4px;
        border: 1px solid #e6e6e7;
        min-height: 36px;
        border-radius: 2px;
        font-size: 12px;
        position: relative;
        z-index: 1;
        background: #fff;
        cursor: pointer;
        overflow: hidden;
        .placeholders {
            margin: 0;
            padding: 0;
            position: absolute;
            top: 10px;
            left: 10px;
            color: #c3cdd7;
        }
        .searcher-footer {
            height: 22px;
            position: relative;
            clear: both;
        }
        .dropdown-list-wrapper {
            min-width: 150px;
            height: auto;
            background: #fff;
            padding: 0;
            margin: 5px 0 0 0;
            position: absolute;
            z-index: 50;
            border-radius: 2px;
            border: 1px solid #c3cdd7;
            box-sizing: border-box;
            opacity: 1;
            transition: all ease 0.3s;
            box-shadow: 0 2px 6px rgba(51,60,72,0.1);
        }
        .dropdown-list {
            width: 100%;
            max-height: 166px;
            list-style: none;
            padding: 0;
            margin: 0;
            a {
                display: block;
                line-height: 36px;
                padding: 0 15px;
                color: #737987;
                font-size: 14px;
                text-decoration: none;
                white-space: nowrap;
                &:hover,
                &.active {
                    background: #ebf4ff;
                    color: #3c96ff;
                }
            }
        }
        .input {
            width: 10px;
            height: 20px;
            padding: 0;
            border: 0;
            box-shadow: border-box;
            outline: none;
            max-width: 295px;
        }
        .actions {
            position: absolute;
            right: 2px;
            top: 1px;
            color: #c4ced8;
            .btn {
                font-size: 16px;
                color: #c4ced8;
                margin-left: 3px;
            }
        }
        .search-keys {
            display: inline-block;
            max-height: 135px;
            overflow: auto;
            float: left;
            margin-top: 0px;
            >li {
                display: inline-block;
                margin: 3px;
                cursor: pointer;
                position: relative;
                padding: 2px;
                border-radius: 2px;
                &.key-node {
                    border: solid 1px #e6e6e7;
                }
            }
            .key-node {
                background: #fafafa;
                padding-right: 16px;
                .remove-key {
                    display: inline-block;
                }
            }
            .remove-key {
                position: absolute;
                width: 16px;
                height: 16px;
                line-height: 16px;
                bottom: 4px;
                right: 3px;
                display: inline-block;
                font-size: 12px;
                text-align: center;
                color: #666;
                display: none;
            }
        }
        .tag {
            display: inline-block;
            background-color: #fafafa;
            color: #666;
            font-size: 14px;
            border: none;
            vertical-align: middle;
            box-sizing: border-box;
            overflow: hidden;
            border-radius: 2px;
            padding: 0 9px;
            min-height: 21px;
            line-height: 21px;
            word-break: break-all;
        }
        .dropdown-actions {
            width: 100%;
            font-size: 0;
            .bk-button {
                width: 50%;
                margin: 0;
                border-radius: 0;
                border-width: 0;
                border-top-width: 1px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// tag.vue?4569c06a